import { Tag } from "@blueprintjs/core";
import type { ScheduledEventRecurringSettings } from "@package/ui-gql/index-data-access";
import moment from "moment";
import { useMemo } from "react";
import { nextOccurrences } from "../scheduler-recurrence-utils";

type SchedulerOccurrencePreviewProps = {
  recurring: ScheduledEventRecurringSettings | null | undefined;
  start: Date;
};

export function SchedulerOccurrencePreview({
  recurring,
  start,
}: SchedulerOccurrencePreviewProps) {
  const occurrences = useMemo(
    () => nextOccurrences(recurring, start, 5),
    [recurring, start],
  );

  if (!occurrences.length) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <span className="text-[11px] font-semibold tracking-wide text-brand-muted uppercase">
        Next
      </span>
      {occurrences.map((date, index) => (
        <Tag key={index} minimal>
          {moment(date).format("MMM D")}
        </Tag>
      ))}
    </div>
  );
}
